import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconClear$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconClear extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '492f7f5becefc70d0763cddac1099f9a5bcca1be', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'ef680b8748c2685a9612532db96dc0c43e21d9c6', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b865c00b86d75b74d3fe796bbab8ed4544668389', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M7.88 5a.48.48 0 0 0-.36.16l-5.2 5.5a.5.5 0 0 0 0 .68l5.2 5.5a.48.48 0 0 0 .36.16H18.5a.5.5 0 0 0 .5-.5v-11a.5.5 0 0 0-.5-.5zm9.62 10.5H8.31L4.06 11l4.25-4.5h9.19zm-3.07-6.99.36.35a.51.51 0 0 1 0 .71L13.35 11l1.44 1.43a.51.51 0 0 1 0 .71l-.36.35a.48.48 0 0 1-.7 0l-1.44-1.43-1.43 1.43a.48.48 0 0 1-.7 0l-.36-.35a.51.51 0 0 1 0-.71L11.23 11 9.8 9.57a.51.51 0 0 1 0-.71l.36-.35a.48.48 0 0 1 .7 0l1.43 1.43 1.44-1.43a.48.48 0 0 1 .7 0", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-clear", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-clear"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-clear":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconClear$1);
            }
            break;
    } });
}

const CosmosIconClear = CosmosIconClear$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconClear, defineCustomElement };
